import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { VariantService } from 'src/app/admin-pages/variant.service';
import { BackOfficeService } from 'src/app/back-office-pages/back-office.service';
import { ApiService } from 'src/app/services/api.service';
import { ConfigService } from 'src/app/services/config.service';
import { PrivilegesService } from 'src/app/services/privileges.service';
import { UtilityService } from 'src/app/services/utility.service';
import { menuItems } from 'src/app/third-party/service-near/menu';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { FeatureFlagService } from 'src/app/services/feature-flag.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SubscriptionsService } from 'src/app/services/subscriptions.service';

@Component({
  selector: 'app-servicenear-side-menu',
  templateUrl: './servicenear-side-menu.component.html',
  styleUrls: ['./servicenear-side-menu.component.scss']
})
export class ServicenearSideMenuComponent implements OnInit, OnDestroy{
  isSearchActive: boolean = false;
  isFilterActive: boolean = false;
  selectedShop: any = { key: 0, a: 'dssdf' };
  originalUser: any;
  loginDetails: any = {};
  isApiError: boolean;
  isShowLogOutConfirm: boolean;
  shopList: any = [{ ShopName: 'All', ID: 0 }];
  CartCount: number = 0;
  selectedUser: any = {};
  isRouteUser: boolean;
  iSelectedRoute: boolean;
  loggedInUserID: number = 0;
  isShowReportList: boolean = false;

  isSuperAdmin!: boolean;
  isSelectedSuper!: boolean;

  isReseller!: boolean;
  shopeDomainName: any;
  appName: string;
  registrationData: any;
  isCollapsed: boolean = true;

  showBackButton: boolean = false;
  menuItemsList: any = menuItems;
  adminDetails: any;
  isOldSwithUIHidden: boolean = false;
  suscriptionFeatures: any = {};
  private subscriptionsToUnsubscribe = new Subscription();

  constructor(
    private router: Router,
    private backOfficeService: BackOfficeService,
    public apiService: ApiService,
    private vs: VariantService,
    // private fcmService: FcmService,
    public configService: ConfigService,
    // public modalService:ModalService
    private route: ActivatedRoute,
    private location: Location,
    private utilityService: UtilityService,
    public privilegeService: PrivilegesService,
    private featureFlagService: FeatureFlagService,
    private subscriptionsService: SubscriptionsService,
  ) { }

  ngOnInit(): void {
    this.privilegeService.getUserPrivileges();
    this.adminDetails = this.apiService.getRealUserData();

    // Subscribe to mobile menu config from API
    const subsSub = this.subscriptionsService.subscriptionFeatures$.subscribe((features: any) => {
      if (features?.mobilemenu) {
        this.setMobileMenuConfig(features.mobilemenu);
      }
    });
    this.subscriptionsToUnsubscribe.add(subsSub);

    // PRIVILEGES
    const dashboardMenu = this.menuItemsList.find(
      item => item.id === 'dashboard'
    );
    if (dashboardMenu && !this.privilegeService.getServicenearPrivilege('dashboard', true)) {
      dashboardMenu.hidden = true;
    }

    const shopCustomersMenu = this.menuItemsList.find(
      item => item.id === 'shopscustomers'
    );

    const addShopItem = shopCustomersMenu?.children.find(
      item => item.id === 'addshop'
    );
    if (addShopItem && !this.privilegeService.getServicenearPrivilege('addShop', true)) {
      addShopItem.disabled = true;
    }

    const shopListItem = shopCustomersMenu?.children.find(
      item => item.id === 'shoplist'
    );
    if (shopListItem && !this.privilegeService.getServicenearPrivilege('listShop', true)) {
      shopListItem.disabled = true;
    }

    const customerListItem = shopCustomersMenu?.children.find(
      item => item.id === 'customerlist'
    );
    if (customerListItem && !this.privilegeService.getServicenearPrivilege('listCustomer', true)) {
      customerListItem.disabled = true;
    }

    const addCustomerItem = shopCustomersMenu?.children.find(
      item => item.id === 'addcustomer'
    );
    if (addCustomerItem && !this.privilegeService.getServicenearPrivilege('addCustomer', true)) {
      addCustomerItem.disabled = true;
    }

    this.isOldSwithUIHidden = this.featureFlagService.getFeatureStatus('hide_servicenear_oldSwitchUI', true);

    // Initial check on load
    this.checkRouteAccess(this.router.url);

    // Listen to router navigation ends
    this.subscriptionsToUnsubscribe.add(
      this.router.events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
        this.checkRouteAccess(event.urlAfterRedirects);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptionsToUnsubscribe.unsubscribe();
  }

  public closeSideNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("myCloseContainer").style.width = "0";
    document.body.style.overflow = ''; // restore default
  }

  private checkRouteAccess(url: string) {
    if (!url) return;

    // Not logged in (session gone): login page, not a 404 - the menu below holds no plan / privileges then.
    // logoutUser sends a ServiceNear seller to ServiceNear and a Tobeonline seller to /public/login
    if (!this.configService.getLoginDetails()?.UserID) {
      this.configService.logoutUser();
      return;
    }

    // Simple check: Is this URL associated with a menu item in the original static menuItems?
    const originalItem = this.findItemByPath(url, menuItems);
    
    if (originalItem) {
      // It is a tracked route. Now check if it exists in the active, filtered menuItemsList
      const activeItem = this.findItemByPath(url, this.menuItemsList);
      
      // If it doesn't exist (because it was hidden) or it exists but is disabled, block access
      if (!activeItem || activeItem.disabled) {
        // Redirect to a non-existent route to trigger the 404 page
        this.router.navigate(['/404']);
      }
    }
  }

  private findItemByPath(url: string, items: any[]): any {
    const urlWithoutParams = url.split('?')[0];
    for (const item of items) {
      if (item.path && item.path !== '' && (urlWithoutParams === item.path || urlWithoutParams.startsWith(item.path + '/'))) {
        return item;
      }
      if (item.children && item.children.length > 0) {
        const found = this.findItemByPath(url, item.children);
        if (found) return found;
      }
    }
    return null;
  }

  public gotoPage(path) {
    if (path === '/servicenear/logout') {
      this.configService.logoutUser(false, true);
    } else if (path === '/?activateoldui=true') {
      this.routeToServicenear();
    } else {
      const currentParams = this.route.snapshot.queryParams;
      this.router.navigate([path], { queryParams: currentParams });
    }
    this.closeSideNav();
  }

  public navigateToJobDetails(itemId: any) {
    const { thirdpartyuserkey, thirdpartyappurl } = this.route.snapshot.queryParams;
    this.router.navigate(['/servicenear/serviceDetails'], { queryParams: { workID: itemId, thirdpartyuserkey, thirdpartyappurl } });
  }

  get profileName(){
    let adminDetails = JSON.parse(localStorage.getItem('admin_Details') || '{}');
    return adminDetails?.Name;
  }

  showReports(event: boolean) {
    if (this.isShowReportList === false) {
      this.isShowReportList = true;
    } else {
      this.isShowReportList = false;
    }
  }

  public routeToServicenear() {
    const thirdPartyAppUrl = this.utilityService.getParamValueFromAnyUrl('thirdpartyappurl');
    const thirdPartyLogoutURl = thirdPartyAppUrl + '/?activateoldui=true';
    window.location.href = thirdPartyLogoutURl;
  }

  public logOutClicked() {
    this.configService.isShowLogOutConfirm = true;
    this.closeSideNav();
    // this.modalService.open(logoutTemplate, false, this.isShowLogOutConfirm);
  }

  ActivateSearch() {
    this.isSearchActive = !this.isSearchActive;
    // this.onSearchClicked.emit(this.isSearchActive);
  }

  public filterClick() {
    // this.isFilterActive = !this.isFilterActive;
    // this.onFilterClick.emit(this.isFilterActive)
    // this.onFilterClick.emit(true);
  }

  public clearUserSelection() {
    this.backOfficeService.clearCustomerSelection();
    this.setUpUser();
    this.gotoPage('/user/userlist');
  }

  private setUpUser() {
    this.selectedUser = this.apiService.getSelecterUserData();
    this.originalUser = this.apiService.getRealUserData();

    this.isRouteUser = this.originalUser?.UserType === 'admin' ? true : false; //removed soon
    this.iSelectedRoute =
      this.selectedUser?.UserType === 'admin' ? true : false; //removed soon

    this.isSuperAdmin =
      this.originalUser.UserType == 'superadmin' ? true : false;
    this.isSelectedSuper =
      this.selectedUser.UserType == 'superadmin' ? true : false;
  }

  public gotoAddProduct() {
    if (this.isReseller) {
      this.router.navigate(['/Reseller/AddProduct']);
    } else {
      if (location.hash.split('/')[2] == "product-edit") {
        this.vs.initVariantService(0);
      }
      this.router.navigate(['/products/product-edit', 0]);
    }
    this.closeSideNav();
  }

  ShareMyStore() {
    const shopeDomainName = this.configService.getLoginDetails()?.SubDomain;
    const appName = environment.appName.toLowerCase();
    const shareableLink = `https://${shopeDomainName}`;

    if (shopeDomainName && appName) {
      if (navigator.share) {
        navigator.share({
          title: 'Share My Store',
          text: 'Check out my store',
          url: shareableLink,
        }).catch((error) => {
          console.error('Sharing failed:', error);
        });
      }
    } else {

    }
    this.closeSideNav();
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  checkBackButton() {
    const currentUrl = this.router.url;
    this.showBackButton = !currentUrl.startsWith('/servicenear/dashboard');
  }

  public gotoContactUsPage(){
    const currentParams = this.route.snapshot.queryParams;
    this.router.navigate(['/servicenear/contactUs'], { queryParams: currentParams });
    this.closeSideNav();
  }

  public goToProfilePage(){
    const currentParams = this.route.snapshot.queryParams;
    this.router.navigate(['/servicenear/profile'], { queryParams: currentParams });
    this.closeSideNav();
  }

  private setMobileMenuConfig(apiMenu: any[]): void {
    // Reset to original menuItems so re-calls don't compound mutations
    this.menuItemsList = menuItems.map((menuItem: any) => ({ ...menuItem,
      children: menuItem.children ? menuItem.children.map((c: any) => ({ ...c })) : undefined
    }));

    // Re-apply privileges that might have hidden or disabled things by default
    const dashboardMenu = this.menuItemsList.find((item: any) => item.id === 'dashboard');
    if (dashboardMenu && !this.privilegeService.getServicenearPrivilege('dashboard', true)) {
      dashboardMenu.hidden = true;
    }

    const shopCustomersMenu = this.menuItemsList.find((item: any) => item.id === 'shopscustomers');
    
    if (shopCustomersMenu) {
      const addShopItem = shopCustomersMenu.children?.find((item: any) => item.id === 'addshop');
      if (addShopItem && !this.privilegeService.getServicenearPrivilege('addShop', true)) { addShopItem.disabled = true; }

      const shopListItem = shopCustomersMenu.children?.find((item: any) => item.id === 'shoplist');
      if (shopListItem && !this.privilegeService.getServicenearPrivilege('listShop', true)) { shopListItem.disabled = true; }

      const customerListItem = shopCustomersMenu.children?.find((item: any) => item.id === 'customerlist');
      if (customerListItem && !this.privilegeService.getServicenearPrivilege('listCustomer', true)) { customerListItem.disabled = true; }

      const addCustomerItem = shopCustomersMenu.children?.find((item: any) => item.id === 'addcustomer');
      if (addCustomerItem && !this.privilegeService.getServicenearPrivilege('addCustomer', true)) { addCustomerItem.disabled = true; }
    }

    this.menuItemsList.forEach((menuItem: any) => {
      const apiMenuItem = apiMenu.find((m: any) => m.id === menuItem.id || (m.label && m.label === menuItem.label));

      if (apiMenuItem) {
        // ── Parent rules
        menuItem.hidden = !apiMenuItem.show;
        menuItem.disabled = apiMenuItem.disable;
        menuItem.positionindex = apiMenuItem.positionindex;

        // ── Children rules (only when parent is visible)
        if (!menuItem.hidden && menuItem.children && apiMenuItem.children?.length) {
          menuItem.children.forEach((childItem: any) => {
            const apiChildItem = apiMenuItem.children.find((c: any) => c.id === childItem.id || (c.label && c.label === childItem.label));
            if (apiChildItem) {
              childItem.hidden = !apiChildItem.show;
              childItem.disabled = apiChildItem.disable;
              childItem.positionindex = apiChildItem.positionindex;
            }
          });

          // Remove hidden children
          menuItem.children = menuItem.children.filter((childItem: any) => !childItem.hidden);

          // Sort children by positionindex
          menuItem.children.sort((a: any, b: any) =>
            (a.positionindex ?? Number.MAX_SAFE_INTEGER) - (b.positionindex ?? Number.MAX_SAFE_INTEGER)
          );
        }

        // ── Force children disabled if parent is disabled
        if (menuItem.disabled && menuItem.children?.length) {
          menuItem.children.forEach((child: any) => {
            child.disabled = true;
          });
        }
      }
    });

    // Remove hidden parents
    this.menuItemsList = this.menuItemsList.filter((menuItem: any) => !menuItem.hidden);

    // Sort parents by positionindex
    this.menuItemsList.sort((a: any, b: any) =>
      (a.positionindex ?? Number.MAX_SAFE_INTEGER) - (b.positionindex ?? Number.MAX_SAFE_INTEGER)
    );

    // Re-verify the current route in case the subscription config just hid/disabled the active page
    this.checkRouteAccess(this.router.url);
  }
}
